import { DashboardModule } from '@domain-group/suit-theme'

import type { ProviderPriceListModel } from '@models/types'

import useProviderPriceList from '@hooks/useProviderPriceList'

import Product from './Product'

interface ProductListProps {
  assignedServiceProductIds: number[],
  callbacks: {
    showCreateOrEditProviderPriceListItemModal: (payload: object) => void,
  },
  isMaster: boolean,
  providerPriceList: ProviderPriceListModel,
}

const ProductList = (props: ProductListProps) => {
  const {
    assignedServiceProductIds,
    callbacks: {
      showCreateOrEditProviderPriceListItemModal,
    },
    isMaster,
    providerPriceList,
  } = props

  const providerPriceListPayload = useProviderPriceList(providerPriceList)
  const {
    callbacks: {
      deleteItemsForProduct,
    },
  } = providerPriceListPayload

  if (!assignedServiceProductIds.length){
    return null
  }

  return (
    <DashboardModule contentBoxProps={{ flexDirection: 'column' }} title="Products">
      {/*
       // @ts-expect-error TS2322 */}
      <DashboardModule.ScrollableSection maxHeight={600}>
        {assignedServiceProductIds.map((serviceProductId, index) => (
          <Product
            callbacks={{
              deleteItemsForProduct: () => deleteItemsForProduct(serviceProductId),
              showCreateOrEditProviderPriceListItemModal: () => showCreateOrEditProviderPriceListItemModal({
                providerPriceListItem: {
                  hidden: false,
                  provider_price_list_id: providerPriceList.id,
                  service_product_id: serviceProductId,
                },
              }),
            }}
            isMaster={isMaster}
            key={serviceProductId}
            last={index + 1 === assignedServiceProductIds.length}
            serviceProductId={serviceProductId}
            providerPriceList={providerPriceList}
          />
        ))}
      </DashboardModule.ScrollableSection>
    </DashboardModule>
  )
}

export default ProductList
